const QUESTION_IDENTIFIER_REGEX = /^[a-z0-9_]+$/;
export const QUESTION_IDENTIFIER_RULE =
  "lowercase letters, numbers, and underscores only";

const SECTION_IDENTIFIER_REGEX = /^[a-z0-9_-]+$/;
export const SECTION_IDENTIFIER_RULE =
  "lowercase letters, numbers, hyphens, and underscores only (no spaces)";

// Context values are usually plain identifiers (e.g. "applicant", "household"),
// but some are internally-generated list IDs (UUIDs) — e.g. custom_pref questions
// use the interest list id as their context. UUIDs contain hyphens, so they must
// be accepted alongside regular identifiers.
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const CONTEXT_VALUE_RULE =
  "lowercase letters, numbers, and underscores only (or a list ID)";

export const isValidQuestionIdentifier = (value: string): boolean =>
  QUESTION_IDENTIFIER_REGEX.test(value.trim());

export const isValidSectionIdentifier = (value: string): boolean =>
  SECTION_IDENTIFIER_REGEX.test(value.trim());

export const isValidContextValue = (value: string): boolean => {
  const trimmed = value.trim();
  return isValidQuestionIdentifier(trimmed) || UUID_REGEX.test(trimmed);
};

export const getInvalidContextTokens = (contextText: string): string[] =>
  contextText
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean)
    .filter((value) => !isValidContextValue(value));
